import logger from './client-logger'

export const handleFatalError = (errorResponse: any, optionalOverrideErrorCode?: string) => {
	logger.error('Error in handleFatalError:', errorResponse)
}
